import { Component, OnInit } from '@angular/core';
import { ModalComponent } from '../../../../vass-core/components/modal/modal.component';
import { MortgageService } from '../../../services/mortgage/mortgage.service';

@Component({
  selector: 'app-life-insurance',
  templateUrl: './life-insurance.component.html',
  styleUrls: ['./life-insurance.component.scss'],
  standalone: false,
})
export class LifeInsuranceComponent implements OnInit {
  public showError = false;

  constructor(
    private modalComponent: ModalComponent,
    private mortgageService: MortgageService,
  ) {}

  ngOnInit() {}

  cancel() {
    this.mortgageService.checkLifeInsurance({ insuranceConditions: false }).subscribe(
      (resp) => {
        this.modalComponent.reject();
      },
      (err) => {
        this.showError = true;
      },
    );
  }

  accept() {
    this.mortgageService.checkLifeInsurance({ insuranceConditions: true }).subscribe(
      (resp) => {
        this.modalComponent.reject();
      },
      (err) => {
        this.showError = true;
      },
    );
  }
}
